/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconHouseFill(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 16 16"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.946.308a1.58 1.58 0 0 0-1.875 0L4.77 2.062.695 5.154A1.75 1.75 0 0 0 0 6.564v7.718C0 15.233.728 16 1.632 16h4.736v-3.445c0-.951.728-1.718 1.632-1.718s1.632.767 1.632 1.718V16h4.736c.904 0 1.632-.767 1.632-1.718V6.564c0-.564-.26-1.084-.695-1.41L11.23 2.062 8.93.308Z"
      />
    </svg>
  );
}
